// src/app/services/deepgram.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { appendWsAuth } from './session-auth.store';

@Injectable({
  providedIn: 'root',
})
export class DeepgramWebSocketService {
  private apiUrl = environment.apiUrl;
  private wsBaseUrl = this.apiUrl.replace(/^http/i, 'ws');
  private wsUrl = `${this.wsBaseUrl}/ws/deepgram/listen?model=nova-2&interim_results=true&encoding=linear16&sample_rate=16000&endpointing=3000`;
  private readonly connectTimeoutMs = 12000;
  private socket: WebSocket | null = null;

  /* connect(): WebSocket {
    this.socket = new WebSocket(this.wsUrl, ['token', this.apiKey]);

    this.socket.onopen = () => {
      console.log('WebSocket connected')
    };
    this.socket.onerror = (error) => console.error('WebSocket error:', error);

    return this.socket;
  } */

  private connectProxySocket(): Promise<WebSocket> {
    return new Promise((resolve, reject) => {
      let settled = false;
      const settle = (fn: () => void) => {
        if (settled) return;
        settled = true;
        clearTimeout(openTimeout);
        fn();
      };

      this.socket = new WebSocket(appendWsAuth(this.wsUrl));
      const openTimeout = setTimeout(() => {
        settle(() => reject(new Error('Deepgram proxy WS open timeout')));
        this.socket?.close();
      }, this.connectTimeoutMs);

      this.socket.onopen = () => {
        console.log('WebSocket connected at deepgram proxy service');
        settle(() => resolve(this.socket as WebSocket));
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket error:', error);
        settle(() => reject(error));
      };

      this.socket.onclose = (event) => {
        console.log('WebSocket closed');
        if (!settled) {
          settle(() => reject(new Error(`Deepgram WS closed before open. code=${event.code}`)));
        }
      };
    });
  }

  async connect(): Promise<WebSocket> {
    try {
      return await this.connectProxySocket();
    } catch (proxyError) {
      // Single retry for transient proxy startup/network hiccups.
      return this.connectProxySocket().catch(() => {
        throw new Error(`Deepgram proxy connect failed: ${String(proxyError)}`);
      });
    }
  }

  disconnect() {
    if (this.socket) {
        const closeStreamMsg = JSON.stringify({ type: "CloseStream" });
        this.socket.send(closeStreamMsg);
      this.socket.close();
      this.socket = null;
      console.log('WebSocket disconnected');
    }
  }

  sendAudioChunk(chunk: ArrayBuffer) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(chunk);
    }
  }
}
